import { Link } from "@tanstack/react-router";
import { Phone, Mail, MapPin } from "lucide-react";

export function Footer() {
  return (
    <footer className="mt-24 border-t border-border bg-primary text-primary-foreground">
      <div className="mx-auto max-w-7xl px-6 py-14 grid gap-10 md:grid-cols-3">
        <div>
          <h3 className="font-display text-xl">The Crew Paint Contractors</h3>
          <p className="mt-3 text-sm text-primary-foreground/75 max-w-xs">
            Honest, high-quality residential painting and wood replacement in Arlington, TX. Over 40 years of craftsmanship.
          </p>
        </div>
        <div className="text-sm space-y-2 text-primary-foreground/85">
          <h4 className="font-display text-base mb-3">Contact</h4>
          <a href="tel:6824545997" className="flex items-center gap-2 hover:text-accent"><Phone className="h-4 w-4" /><span>682-454-5997</span></a>
          <a href="mailto:thecrew1962@gmail.com" className="flex items-center gap-2 hover:text-accent"><Mail className="h-4 w-4" /><span>thecrew1962@gmail.com</span></a>
          <p className="flex items-center gap-2"><MapPin className="h-4 w-4" /><span>Arlington, Texas</span></p>
        </div>
        <div className="text-sm space-y-2">
          <h4 className="font-display text-base mb-3">Navigation</h4>
          {[
            { to: "/", label: "Home" },
            { to: "/services", label: "Services" },
            { to: "/about", label: "About" },
            { to: "/faq", label: "How It Works" },
            { to: "/contact", label: "Contact" },
          ].map((l) => (
            <Link key={l.to} to={l.to} className="block text-primary-foreground/75 hover:text-accent">{l.label}</Link>
          ))}
        </div>
      </div>
      <div className="border-t border-primary-foreground/15">
        <div className="mx-auto max-w-7xl px-6 py-5 text-xs text-primary-foreground/60 flex flex-wrap justify-between gap-2">
          <span>© {new Date().getFullYear()} thecrewpaintcontractors.com. All rights reserved.</span>
          <span>Owned & operated by Bart Baldwin</span>
        </div>
      </div>
    </footer>
  );
}
